var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPullTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 0H51C51.6229 0 52.0001 0.45721 52 1.02124V5.94598C52 9.61596 51.3491 14.4929 51 16C50 19 49.1551 20.4142 49 21V24V27H51C51.6229 27 52 27.436 52 28V33C52 33.564 51.6229 34 51 34H47.7123C46.9168 34 46.3894 34.8304 46.7487 35.5402C46.8681 35.7762 46.9644 35.9566 47 36L52.4796 43.3062C52.7782 43.7043 52.7386 44.2614 52.3867 44.6133L49.698 47.302C49.3111 47.6889 48.6849 47.693 48.293 47.3111L38.8398 38.0997C38.1136 37.3453 36.2845 36.8807 34.5 36.8807C33.2107 36.8807 30.5 37 30 38C30 38 29.2812 39.001 29 39.001H25C24.3771 39.001 24 38.564 24 38V37H21V47C21 47.564 20.3898 48 19.7669 48H11C10.3771 48 10 47.564 10 47V25C10 24.436 10.3771 24 11 24H19.7669C20.3898 24 21 24.7289 21 25.2929V27H24V25.2933C24 24.7293 24.3771 24 25 24H29C30 24 30.2216 24.4483 30.427 24.7324C30.4542 24.7693 31.305 27 34 27H43V24V21C42.8627 20.4837 41.55 18.7 41 16C40.1591 11.8732 40 8.62837 40 6.02522V1.02124C40 0.45721 40.3771 0 41 0Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 53.5C37 52.6716 37.6716 52 38.5 52H41C42.1046 52 43 52.8954 43 54V81C43 83.2091 44.7909 85 47 85H67C69.2091 85 71 83.2091 71 81V54C71 52.8954 71.8954 52 73 52H75.5C76.3284 52 77 52.6716 77 53.5C77 54.3284 76.3284 55 75.5 55H74V82C74 85.3137 71.3137 88 68 88H46C42.6863 88 40 85.3137 40 82V55H38.5C37.6716 55 37 54.3284 37 53.5Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48L53.5 44.5L54.8112 46.0734C55.6011 47.0213 56.2787 48.0574 56.8305 49.1609L58 51.5L59.5743 55.8293C59.8573 56.6077 60.059 57.4133 60.1762 58.2332L60.8571 63H69V80C69 81.6569 67.6569 83 66 83H48C46.3431 83 45 81.6569 45 80V63H53V62.0311C53 59.3503 52.7352 56.676 52.2094 54.0472C52.0701 53.3505 51.8672 52.6681 51.6034 52.0085L50 48Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullTap);
export default __webpack_public_path__ + "static/media/pull_tap.b4d350b8767fbe1d79b99ab671b6100b.svg";
export { ForwardRef as ReactComponent };